import "core-js/modules/es6.reflect.construct.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.from.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _typeof from "@babel/runtime/helpers/typeof";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["prefixCls", "transitionName", "popupClassName", "size", "disabled", "builtinPlacements", "popupPlacement", "children", "placeholder"];

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.array.filter.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * This source code is quoted from rc-cascader.
 * homepage: https://github.com/react-component/cascader
 */
import React, { Component, cloneElement } from 'react';
import PropTypes from 'prop-types';
import Trigger from 'rc-trigger';
import warning from 'warning';
import { KeyCode } from '../../../wui-core/src';
import arrayTreeFilter from 'array-tree-filter';
import shallowEqualArrays from 'shallow-equal/arrays';
import { polyfill } from 'react-lifecycles-compat';
import Menus from './Menus';
import Icon from '../../../wui-icon/src';
import FormControl from '../../../wui-input/src';
import InputGroup from '../../../wui-input-group/src';
import { prefix } from "../../../wui-core/src/index.js";
var BUILT_IN_PLACEMENTS = {
  bottomLeft: {
    points: ['tl', 'bl'],
    offset: [0, 4],
    overflow: {
      adjustX: 1,
      adjustY: 1
    }
  },
  topLeft: {
    points: ['bl', 'tl'],
    offset: [0, -4],
    overflow: {
      adjustX: 1,
      adjustY: 1
    }
  },
  bottomRight: {
    points: ['tr', 'br'],
    offset: [0, 4],
    overflow: {
      adjustX: 1,
      adjustY: 1
    }
  },
  topRight: {
    points: ['br', 'tr'],
    offset: [0, -4],
    overflow: {
      adjustX: 1,
      adjustY: 1
    }
  }
};
var self;

var Rcascader = /*#__PURE__*/function (_Component) {
  _inherits(Rcascader, _Component);

  var _super = _createSuper(Rcascader);

  function Rcascader(_props) {
    var _this;

    _classCallCheck(this, Rcascader);

    _this = _super.call(this, _props);

    _defineProperty(_assertThisInitialized(_this), "getInitValue", function (props, valueArray) {
      var value = ''; //用于传给后台

      var inputValue = ''; //用于显示

      if (typeof valueArray[0] == 'string') {
        //值格式为:['a','b','c',...]
        var objectValue = _this.convertStringToObject(props.options, valueArray, [], 0);

        value = objectValue || [];
        inputValue = objectValue.map(function (o) {
          return o.label;
        }).join(props.separator) || '';
      } else if (_typeof(valueArray[0]) == 'object') {
        //值格式为：[{lable:'xxx',value:'yyy'},....]
        value = valueArray.map(function (o) {
          return o.value;
        }) || [];
        inputValue = valueArray.map(function (o) {
          return o.label;
        }).join(props.separator) || '';
      }

      return {
        value: value,
        inputValue: inputValue
      };
    });

    _defineProperty(_assertThisInitialized(_this), "setPopupVisible", function (popupVisible) {
      if (!('popupVisible' in _this.props)) {
        _this.setState({
          popupVisible: popupVisible
        });
      } // sync activeValue with value when panel open


      if (popupVisible && !_this.state.popupVisible) {
        _this.setState({
          activeValue: _this.state.value
        });
      }

      _this.props.onPopupVisibleChange(popupVisible);
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (options, setProps, e) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          separator = _this$props.separator;

      if (e.type !== 'keydown' || e.keyCode === KeyCode.ENTER) {
        onChange(options.map(function (o) {
          return o[_this.getFieldName('value')];
        }), options);

        _this.setState({
          inputValue: options.map(function (o) {
            return o[_this.getFieldName('label')];
          }).join(separator)
        });

        _this.setPopupVisible(setProps.visible);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handlePopupVisibleChange", function (popupVisible) {
      _this.setPopupVisible(popupVisible);
    });

    _defineProperty(_assertThisInitialized(_this), "handleMenuSelect", function (targetOption, menuIndex, e) {
      // Keep focused state for keyboard support
      var triggerNode = _this.trigger.getRootDomNode();

      if (triggerNode && triggerNode.focus) {
        triggerNode.focus();
      }

      var _this$props2 = _this.props,
          changeOnSelect = _this$props2.changeOnSelect,
          loadData = _this$props2.loadData,
          expandTrigger = _this$props2.expandTrigger;

      if (!targetOption || targetOption.disabled) {
        return;
      }

      var activeValue = _this.state.activeValue;
      activeValue = activeValue.slice(0, menuIndex + 1);
      activeValue[menuIndex] = targetOption[_this.getFieldName('value')];

      var activeOptions = _this.getActiveOptions(activeValue);

      if (targetOption.isLeaf === false && !targetOption[_this.getFieldName('children')] && loadData) {
        if (changeOnSelect) {
          _this.handleChange(activeOptions, {
            visible: true
          }, e);
        }

        _this.setState({
          activeValue: activeValue
        });

        loadData(activeOptions);
        return;
      }

      var newState = {};

      if (!targetOption[_this.getFieldName('children')] || !targetOption[_this.getFieldName('children')].length) {
        _this.handleChange(activeOptions, {
          visible: false
        }, e); // set value to activeValue when select leaf option


        newState.value = activeValue; // add e.type judgement to prevent `onChange` being triggered by mouseEnter
      } else if (changeOnSelect && (e.type === 'click' || e.type === 'keydown')) {
        if (expandTrigger === 'hover') {
          _this.handleChange(activeOptions, {
            visible: false
          }, e);
        } else {
          _this.handleChange(activeOptions, {
            visible: true
          }, e);
        } // set value to activeValue on every select


        newState.value = activeValue;
      }

      newState.activeValue = activeValue; //  not change the value by keyboard

      if ('value' in _this.props || e.type === 'keydown' && e.keyCode !== KeyCode.ENTER) {
        delete newState.value;
      }

      _this.setState(newState);
    });

    _defineProperty(_assertThisInitialized(_this), "handleItemDoubleClick", function () {
      var changeOnSelect = _this.props.changeOnSelect;

      if (changeOnSelect) {
        _this.setPopupVisible(false);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (e) {
      var children = _this.props.children; // https://github.com/ant-design/ant-design/issues/6717
      // Don't bind keyboard support when children specify the onKeyDown

      if (children && children.props.onKeyDown) {
        children.props.onKeyDown(e);
        return;
      }

      var activeValue = _toConsumableArray(_this.state.activeValue);

      var currentLevel = activeValue.length - 1 < 0 ? 0 : activeValue.length - 1;

      var currentOptions = _this.getCurrentLevelOptions();

      var currentIndex = currentOptions.map(function (o) {
        return o[_this.getFieldName('value')];
      }).indexOf(activeValue[currentLevel]);

      if (e.keyCode !== KeyCode.DOWN && e.keyCode !== KeyCode.UP && e.keyCode !== KeyCode.LEFT && e.keyCode !== KeyCode.RIGHT && e.keyCode !== KeyCode.ENTER && e.keyCode !== KeyCode.SPACE && e.keyCode !== KeyCode.BACKSPACE && e.keyCode !== KeyCode.ESC) {
        return;
      } // Press any keys above to reopen menu


      if (!_this.state.popupVisible && e.keyCode !== KeyCode.BACKSPACE && e.keyCode !== KeyCode.LEFT && e.keyCode !== KeyCode.RIGHT && e.keyCode !== KeyCode.ESC) {
        _this.setPopupVisible(true);

        return;
      }

      if (e.keyCode === KeyCode.DOWN || e.keyCode === KeyCode.UP) {
        e.preventDefault();
        var nextIndex = currentIndex;

        if (nextIndex !== -1) {
          if (e.keyCode === KeyCode.DOWN) {
            nextIndex += 1;
            nextIndex = nextIndex >= currentOptions.length ? 0 : nextIndex;
          } else {
            nextIndex -= 1;
            nextIndex = nextIndex < 0 ? currentOptions.length - 1 : nextIndex;
          }
        } else {
          nextIndex = 0;
        }

        activeValue[currentLevel] = currentOptions[nextIndex][_this.getFieldName('value')];
      } else if (e.keyCode === KeyCode.LEFT || e.keyCode === KeyCode.BACKSPACE) {
        e.preventDefault();
        activeValue.splice(activeValue.length - 1, 1);
      } else if (e.keyCode === KeyCode.RIGHT) {
        e.preventDefault();

        if (currentOptions[currentIndex] && currentOptions[currentIndex][_this.getFieldName('children')]) {
          activeValue.push(currentOptions[currentIndex][_this.getFieldName('children')][0][_this.getFieldName('value')]);
        }
      } else if (e.keyCode === KeyCode.ESC) {
        _this.setPopupVisible(false);

        return;
      }

      if (!activeValue || activeValue.length === 0) {
        _this.setPopupVisible(false);
      }

      var activeOptions = _this.getActiveOptions(activeValue);

      var targetOption = activeOptions[activeOptions.length - 1];

      _this.handleMenuSelect(targetOption, activeOptions.length - 1, e);

      if (_this.props.onKeyDown) {
        _this.props.onKeyDown(e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "saveTrigger", function (node) {
      _this.trigger = node;
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseLeave", function (e) {
      _this.setState({
        showClose: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseEnter", function (e) {
      _this.setState({
        showClose: true
      });
    });

    self = _assertThisInitialized(_this);
    var initOptions = [];
    var initValueObj = {};

    if ('value' in _props && Array.isArray(_props.value)) {
      //包裹在表单中走value
      initValueObj = _this.getInitValue(_props, _props.value);
    } else if ('defaultValue' in _props && Array.isArray(_props.defaultValue)) {
      //单独使用则直接设置defaultValue
      initValueObj = _this.getInitValue(_props, _props.defaultValue);
    } else if ('options' in _props) {
      initOptions = _props.options || [];
    }

    warning(!('filedNames' in _props), '`filedNames` of Cascader is a typo usage and deprecated, please use `fieldNames` instead.');
    _this.state = {
      popupVisible: _props.popupVisible,
      activeValue: initValueObj.value || [],
      value: initValueObj.value || [],
      prevProps: _props,
      showClose: false,
      //是否显示清空按钮
      inputValue: initValueObj.inputValue || "" //输入框显示的值

    };
    _this.defaultFieldNames = {
      label: 'label',
      value: 'value',
      children: 'children'
    };
    return _this;
  } //设置初始化值


  _createClass(Rcascader, [{
    key: "getPopupDOMNode",
    value: function getPopupDOMNode() {
      return this.trigger.getPopupDomNode();
    }
  }, {
    key: "getFieldName",
    value: function getFieldName(name) {
      var defaultFieldNames = this.defaultFieldNames;
      var _this$props3 = this.props,
          fieldNames = _this$props3.fieldNames,
          filedNames = _this$props3.filedNames;

      if ('filedNames' in this.props) {
        return filedNames[name] || defaultFieldNames[name]; // For old compatibility
      }

      return fieldNames[name] || defaultFieldNames[name];
    }
  }, {
    key: "getFieldNames",
    value: function getFieldNames() {
      var _this$props4 = this.props,
          fieldNames = _this$props4.fieldNames,
          filedNames = _this$props4.filedNames;

      if ('filedNames' in this.props) {
        return filedNames; // For old compatibility
      }

      return fieldNames;
    }
  }, {
    key: "getCurrentLevelOptions",
    value: function getCurrentLevelOptions() {
      var _this2 = this;

      var _this$props$options = this.props.options,
          options = _this$props$options === void 0 ? [] : _this$props$options;
      var _this$state$activeVal = this.state.activeValue,
          activeValue = _this$state$activeVal === void 0 ? [] : _this$state$activeVal;
      var result = arrayTreeFilter(options, function (o, level) {
        return o[_this2.getFieldName('value')] === activeValue[level];
      }, {
        childrenKeyName: this.getFieldName('children')
      });

      if (result[result.length - 2]) {
        return result[result.length - 2][this.getFieldName('children')];
      }

      return _toConsumableArray(options).filter(function (o) {
        return !o.disabled;
      });
    }
  }, {
    key: "getActiveOptions",
    value: function getActiveOptions(activeValue) {
      var _this3 = this;

      return arrayTreeFilter(this.props.options || [], function (o, level) {
        return o[_this3.getFieldName('value')] === activeValue[level];
      }, {
        childrenKeyName: this.getFieldName('children')
      });
    }
  }, {
    key: "resetValue",
    value: function resetValue(e) {
      e.stopPropagation();
      e.preventDefault();
      this.handlePopupVisibleChange(false);
      this.setState({
        inputValue: '',
        activeValue: [],
        value: []
      });
      this.props.onChange && this.props.onChange('');
    } //通过字符串键值生成对象值

  }, {
    key: "convertStringToObject",
    value: function convertStringToObject(options, value, objectValue, count) {
      var _iterator = _createForOfIteratorHelper(options),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;

          if (item.value === value[count]) {
            var deepCopyItem = JSON.parse(JSON.stringify(item));

            if (item.children) {
              delete deepCopyItem.children;
              objectValue.push(deepCopyItem);
              this.convertStringToObject(item.children, value, objectValue, ++count);
            } else {
              objectValue.push(deepCopyItem);
              break;
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return objectValue;
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$state = this.state,
          showClose = _this$state.showClose,
          popupVisible = _this$state.popupVisible,
          inputValue = _this$state.inputValue,
          options = _this$state.options,
          activeValue = _this$state.activeValue,
          value = _this$state.value;

      var _this$props5 = this.props,
          prefixCls = _this$props5.prefixCls,
          transitionName = _this$props5.transitionName,
          popupClassName = _this$props5.popupClassName,
          size = _this$props5.size,
          disabled = _this$props5.disabled,
          builtinPlacements = _this$props5.builtinPlacements,
          popupPlacement = _this$props5.popupPlacement,
          children = _this$props5.children,
          placeholder = _this$props5.placeholder,
          restProps = _objectWithoutProperties(_this$props5, _excluded); // Did not show popup when there is no options


      var menus = /*#__PURE__*/React.createElement("div", null);
      var emptyMenuClassName = '';
      var iconClass = !popupVisible ? "uf-treearrow-down" : "uf-gridcaretarrowup";
      var boxContainer = inputValue && showClose ? "".concat(prefix, "-cascader-group-btn-simple") : "".concat(prefix, "-cascader-group-btn-zoom");

      if (options && options.length > 0) {
        menus = /*#__PURE__*/React.createElement(Menus, _extends({}, this.props, {
          fieldNames: this.getFieldNames(),
          defaultFieldNames: this.defaultFieldNames,
          activeValue: this.state.activeValue,
          onSelect: this.handleMenuSelect,
          onItemDoubleClick: this.handleItemDoubleClick,
          visible: this.state.popupVisible,
          value: this.state.value
        }));
      } else {
        emptyMenuClassName = " ".concat(prefixCls, "-menus-empty");
      }

      return /*#__PURE__*/React.createElement(Trigger, _extends({
        ref: this.saveTrigger
      }, restProps, {
        options: options,
        disabled: disabled,
        popupPlacement: popupPlacement,
        builtinPlacements: builtinPlacements,
        popupTransitionName: transitionName,
        action: disabled ? [] : ['click'],
        popupVisible: disabled ? false : this.state.popupVisible,
        onPopupVisibleChange: this.handlePopupVisibleChange,
        prefixCls: "".concat(prefixCls, "-menus"),
        popupClassName: popupClassName + emptyMenuClassName,
        popup: menus
      }), /*#__PURE__*/React.createElement(InputGroup, {
        simple: true,
        className: "".concat(prefixCls, "-input-group ").concat(boxContainer),
        onMouseEnter: this.onMouseEnter,
        onMouseLeave: this.onMouseLeave
      }, /*#__PURE__*/React.createElement(FormControl, {
        disabled: disabled ? true : false,
        placeholder: placeholder,
        value: inputValue,
        size: size,
        type: "text",
        readOnly: true
      }), inputValue && showClose ? /*#__PURE__*/React.createElement(InputGroup.Button, {
        shape: "border",
        onClick: function onClick(e) {
          return _this4.resetValue(e);
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "uf uf-close-c"
      })) : /*#__PURE__*/React.createElement(InputGroup.Button, {
        shape: "border",
        onClick: function onClick(e) {
          _this4.props.keyboardInput ? _this4.iconClick(e) : '';
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "uf ".concat(iconClass, " ").concat(prefix, "-cascader-group-zoom")
      }))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var _prevState$prevProps = prevState.prevProps,
          prevProps = _prevState$prevProps === void 0 ? {} : _prevState$prevProps;
      var newState = {
        prevProps: nextProps
      };

      if ('value' in nextProps && !shallowEqualArrays(prevProps.value, nextProps.value)) {
        newState.value = nextProps.value || []; // allow activeValue diff from value

        if (!('loadData' in nextProps)) {
          newState.activeValue = nextProps.value || [];
        } // newState.inputValue = self.convertStringToObject(self.props.options,nextProps.value,[],0,).map(o =>o.label).join(nextProps.separator) || ''


        var initValueObj = self.getInitValue(nextProps, nextProps.value);
        newState.inputValue = initValueObj.inputValue || '';
        newState.activeValue = initValueObj.value || [];
        newState.value = initValueObj.value || [];
      }

      if ('popupVisible' in nextProps) {
        newState.popupVisible = nextProps.popupVisible;
      }

      if ('options' in nextProps) {
        newState.options = nextProps.options || [];
      }

      if ('inputValue' in nextProps) {
        newState.inputValue = nextProps.inputValue;
      }

      return newState;
    }
  }]);

  return Rcascader;
}(Component);

Rcascader.defaultProps = {
  onChange: function onChange() {},
  onPopupVisibleChange: function onPopupVisibleChange() {},
  size: 'md',
  disabled: false,
  transitionName: '',
  prefixCls: 'rc-cascader',
  defaultValue: [],
  value: null,
  popupClassName: '',
  popupPlacement: 'bottomLeft',
  builtinPlacements: BUILT_IN_PLACEMENTS,
  expandTrigger: 'click',
  fieldNames: {
    label: 'label',
    value: 'value',
    children: 'children'
  },
  expandIcon: /*#__PURE__*/React.createElement(Icon, {
    type: "uf-arrow-right"
  }),
  separator: '/ '
};
Rcascader.propTypes = {
  size: PropTypes.string,
  value: PropTypes.array,
  defaultValue: PropTypes.array,
  options: PropTypes.array.isRequired,
  onChange: PropTypes.func,
  onPopupVisibleChange: PropTypes.func,
  popupVisible: PropTypes.bool,
  disabled: PropTypes.bool,
  transitionName: PropTypes.string,
  popupClassName: PropTypes.string,
  popupPlacement: PropTypes.string,
  prefixCls: PropTypes.string,
  dropdownMenuColumnStyle: PropTypes.object,
  builtinPlacements: PropTypes.object,
  loadData: PropTypes.func,
  changeOnSelect: PropTypes.bool,
  children: PropTypes.node,
  onKeyDown: PropTypes.func,
  expandTrigger: PropTypes.string,
  fieldNames: PropTypes.object,
  filedNames: PropTypes.object,
  // typo but for compatibility
  expandIcon: PropTypes.node,
  loadingIcon: PropTypes.node,
  inputValue: PropTypes.string,
  separator: PropTypes.string
};
polyfill(Rcascader);
export default Rcascader;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-cascader/src/rc/index.js